import environment from "src/utils/environment";

const { appName, publicPath } = environment;
const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");

function getImageSrc(videoName, { directory = "videos" } = {}) {
  const appPath = app.getAppPath();
  let result;

  const relativePath = path.join(appName, directory);
  const directoryPath = path.join(appPath, relativePath);

  const imagePath = path.join(directoryPath, videoName);
  if (fs.existsSync(imagePath)) result = "file://" + imagePath;

  return result;
}

function getBrowserImagePath(videoName, { directory = "videos" } = {}) {
  const path = `${publicPath}/${appName}/${directory}/${videoName}`;
  return path;
}

export default environment.isBrowser ? getBrowserImagePath : getImageSrc;
